import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { FileUploadModule } from 'primeng/fileupload';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { NGXLogger } from 'ngx-logger';
import { Scheda } from '../../../models/scheda.model';
import { FirebaseStorageService } from '../../../services/firebase-storage.service';
import { LottieComponent, AnimationOptions } from 'ngx-lottie';
import player from 'lottie-web';

export function playerFactory() {
  return player;
}

@Component({
  selector: 'app-carica-immagini',
  templateUrl: './carica-immagini.component.html',
  styleUrls: ['./carica-immagini.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    DialogModule,
    ButtonModule,
    FileUploadModule,
    ToastModule,
    LottieComponent
  ],
  providers: [MessageService]
})
export class CaricaImmaginiComponent implements OnInit {
  display: boolean = false;
  scheda: Scheda | null = null;
  uploadedFiles: any[] = [];
  selectedFiles: any[] = [];
  maxFileSize: number = 10000000; // 10MB
  choseLabel: string = 'Seleziona';
  isUploading: boolean = false;

  options: AnimationOptions = {
    path: '/assets/animations/spinner-uploading.json',
    loop: true,
    autoplay: true
  };

  constructor(
    private logger: NGXLogger,
    private messageService: MessageService,
    private firebaseStorageService: FirebaseStorageService
  ) {}

  ngOnInit() {}

  show(scheda: Scheda) {
    this.scheda = scheda;
    this.display = true;
    this.uploadedFiles = [];
  }

  onSelect(event: any) {
    this.choseLabel = 'Aggiungi';
    /* const files = event.files;
    if (files && files.length > 0) {
      this.uploadedFiles = [...this.uploadedFiles, ...files];
    } */
    this.logger.info("onSelect: " + this.uploadedFiles.length);
  }

  onFileUpload(event: any) {
    this.choseLabel = 'Aggiungi';
    this.uploadedFiles = event.files;

    this.logger.info("onUpload: " + this.uploadedFiles.length);
  }
  onFileRemove() {
    this.choseLabel = 'Seleziona';
    //this.uploadedFiles = [];
  }

  onError(event: any) {
    this.messageService.add({
      severity: 'error',
      summary: 'Errore',
      detail: 'Si è verificato un errore durante il caricamento dei file'
    });
  }



  confermaCaricamento() {
    if (this.uploadedFiles.length === 0) return;
    this.isUploading = true;
    /* this.messageService.add({
      severity: 'info',
      summary: 'Caricamento in corso',
      detail: 'Sto caricando le immagini...'
    }); */

    this.uploadToFirebase();
  }

  private uploadToFirebase() {
    if (!this.scheda || this.uploadedFiles.length === 0) return;

    let filesCaricati = 0;
    const totalFiles = this.uploadedFiles.length;


    this.uploadedFiles.forEach(file => {
      const path = `schede/${this.scheda?.codice}/immagini/${file.name}`;

      this.firebaseStorageService.uploadFile(file, path)
        .subscribe({
          next: () => {
            this.logger.info(`[CARICA IMMAGINI] File ${file.name} caricato con successo`);
            filesCaricati++;

            if (filesCaricati === totalFiles) {
              this.messageService.add({
                severity: 'success',
                summary: 'Caricamento completato',
                detail: `${filesCaricati} immagini caricate con successo`
              });
              this.resetMaschera();
            }
          },
          error: (error: Error) => {
            this.logger.error(`[CARICA IMMAGINI] Errore durante il caricamento di ${file.name}:`, error);
            this.messageService.add({
              severity: 'error',
              summary: 'Errore',
              detail: `Errore durante il caricamento di ${file.name}`
            });
            this.resetMaschera();
          }
        });
      });
  }

  private resetMaschera() {
    this.uploadedFiles = [];
    this.choseLabel = 'Seleziona';
    this.display = false;
    this.isUploading = false;
  }
}
